import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import Waiter from "../../../controls/Waiter.mjs";
import BLib from "../BLib.mjs";
import TextLabel from "../../../controls/TextLabel.mjs";
import {Button, ButtonGroup} from "reactstrap";
import ReloadIcon from "../../../media/assets/ReloadIcon.mjs";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";
import MessaggiRender from "../Messaggi/MessaggiRender.mjs";
import appLib from "../../../libs/appLib.mjs";
import EditMessage from "../Messaggi/EditMessage.mjs";

const prefix = "MyAds";

const MyAds = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: appLib.currentUser()
		};
		this.uid = Glob.generateUid(prefix);
		this.load = this.load.bind(this);
	}
	componentDidMount() {
		Glob.register('MessaggeEdit', m => {
			this.setState({composing: m}, ()=>{
				if ( ! m ) setTimeout( this.load );
			});
		}, this.uid);
		this.load();
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	load(){
		this.setState({ loading: true }, () => {
			BLib.myAds().then( res => {
				const data = (res?.messaggi && res.messaggi[0]) ? res.messaggi : false;
				this.setState({ data: data });
			}).catch((err) => {
				if ( err?.message && err.message.startsWith('401')) {
					appLib.logout();
					this.close();
				}
			}).finally(() => {
				this.setState({ loading: false });
			});
		});
	}
	close() {
		Glob.trigger('my_user_messages', false);
	}
	render() {
		if ( this.state.loading ) return <Waiter />;
		if ( this.state.composing) return(
			<EditMessage
				value={ this.state.composing }
				axle={ this.state.composing?.axle }
				user={ this.state.user }
			/>
		)
		return(
			<div className={prefix}>
				<h4>
					<TextLabel value={"My ads"} />
					<span
						className={"closer"}
						onClick={ this.close }
					>
						<CloseIcon />
					</span>
				</h4>
				{ this.state.data ? (
					<MessaggiRender
						data={this.state.data}
						user={ this.state.user }
					/>
				) : (
					<>
						<h4 className={"error mt-4 mb-4"}>
							<TextLabel value={"No items found"} />
						</h4>
						<ButtonGroup
							className={"btn-icon"}
						>
							<Button
								color="success"
								onClick={ ()=>{ Glob.trigger('my_user_messages', false); }}
							>
								<i>
									<CloseIcon />
								</i>
								<b>
									<TextLabel value={"Cancel"} />
								</b>
							</Button>
							<Button
								color="warning"
								onClick={ this.load }
							>
								<b>
									<TextLabel value={"Reload"} />
								</b>
								<i>
									<ReloadIcon />
								</i>
							</Button>
						</ButtonGroup>
					</>
				)}
			</div>
		)

	}
}

export default MyAds;